import { makePrefixAdder } from '../../redux/utils/type-utils';

const APP = makePrefixAdder('APP');
export const LOGOUT = APP('LOGOUT');
export const logout = () => ({ type: LOGOUT });
